<template>
    <div class="greybox">
        <div v-if="selectedClaim && isBankDetailsEmpty">
        <h1>Please provide your bank details...</h1>
        <p class="lead">We need this so we can reimburse you for the repair minus any excess owed.</p>
        <bankDetails ref="bankDetails" v-model="bankObject"  @isValid="handleBankDetailsIsValid" />
        <div class="button-fluid-container">
            <button @click="handleCloseClick()" class="button">Cancel</button>
            <button class="button" @click="handleUpdateClaim(selectedGadgetId)">
                <span v-if="standAlone === false">Continue</span>
                <span v-else>OK</span>
            </button>
        </div>
        </div>
        <div v-else>Loading...</div>

        <loading :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>
<script>
import repairOptionsBase from '@/mixins/repairOptionsBase'
import bankDetails from '@/components/BankDetails'
import loading from 'vue-loading-overlay'
import axios from 'axios'
import { mapActions } from 'vuex'

let baseUrl = process.env.VUE_APP_API_BASE_URL
const DEFAULT_PATH = '/'

export default {
    name: 'RepairOptionsBankDetails',
    components: {
        bankDetails,
        loading
    },
    mixins: [
        repairOptionsBase
    ],
    beforeRouteEnter (to, from, next) {
        next(vm => {
            // check for login and keep default...
            let { path } = from
            if (path != '/login') {
                vm.referer = path
            }})
    },
    beforeMount () {        
        this.loadSelectedClaim(this.selectedGadgetId)

        if (this.$route.params.standAlone === true) {
            this.standAlone = this.$route.params.standAlone;
        } else {
            this.standAlone = false;
        }
    },
    data: () => {
        return {
            referer: DEFAULT_PATH,
            bankObject: {
                name: "",
                accountName: "",
                accountNumber: "",
                accountSortCode: ""
            },
            bankDetailsValid: false,
            standAlone: false
        }
    },
    computed: {
        isLoading() {
            if(this.selectedClaim == null) {
                return true
            } else {
                return false
            }
        },
        selectedClaim() {
            return this.$store.state.myclaims.selectedClaim
        },
        isBankDetailsEmpty () {
            let { bankDetails } = this.$store.state.myclaims.selectedClaim
            if (bankDetails) {
                return bankDetails.name == '' || bankDetails.name == null
            }
            return true
        }
    },
    watch:{
        selectedClaim: function(val) {
            if (this.selectedClaim) {
                if (!this.isBankDetailsEmpty) {
                    this.$router.push({ path: '/myclaims/repairoptions/uploaddocs' })
                }
            }
        }
    },
    methods: {
        handleBankDetailsIsValid (value) {
            this.bankDetailsValid = value
        },
        handleUpdateClaim () {
            
            if (this.$refs.bankDetails.checkForm()) {
                let bankObj = {
                    claimWebReference: this.claimWebRef,
                    ...this.bankObject
                }
                axios
                    .post(baseUrl + '/api/v1/payment/banktrans/' + this.selectedClaim.id, bankObj)
                    .then(res => {
                        
                        let { success } = res.data.data
                        if (success == true) {
                            if(this.standAlone) {
                                this.$router.push({ path: this.referer })
                            } else {
                                this.$router.push({ path: '/myclaims/repairoptions/uploaddocs' })
                            }                            
                        }
                    })
                    .catch(err => {
                    
                    })
            }
        },
        handleCloseClick () {
            this.$router.push({ path: this.referer })
        },
        ...mapActions({
            load: 'myclaims/getClaim'
        })
    },
    mounted () {
        this.load(this.$route.params.id);
    }
}
</script>

